import globalStore from '$$globalStore';
import numbersHelper from '../../helpers/numbers';

export default function (number) {
  const currencySign = globalStore.getters['teamSetting/enableCurrency']
    ? GT.currency.find(item => item.ID === globalStore.getters['teamSetting/currency'])?.VALUE || ''
    : '';

  return currencySign + numbersHelper.getFormatted(number);
}
